/**
 * Converted from flindersonline-frontend component
 * GSAP and Swiper are available as global variables
 * Original imports have been removed and replaced with global access
 */

// In Hero Banner (Single Image/Single Video/Multi Video/Carousel)
// Import GSAP
// gsap is available globally
// ScrollTrigger is available globally via gsap
// Import Swiper and required modules
// Swiper is available globally
// Swiper modules are available globally

// Import Swiper styles
// Swiper CSS is included globally
// Swiper CSS is included globally
// Swiper CSS is included globally

(function() {
	"use strict"
	
	// Check if mobile device (optional)
	var isMobile = window.innerWidth < 992; // /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
	const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
	const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
	
	// ScrollTrigger is now registered globally in scrolltrigger-config.js

	// Adjust Start Point if Header is Sticky
	const header = document.querySelector('.main_header_container');
	const notification = document.querySelector('.cmp-flindersonline-notification') || null;
	const isSticky = window.getComputedStyle(header)?.position === 'sticky';
	var headerOffset = isSticky ? (notification?.classList.contains('hidden') ? header?.offsetHeight : header?.offsetHeight + 48) : 0;
	var hasHashTagOnLoad = false;

	let isSmoothScrolling = false;

	window.addEventListener('wheel', () => isSmoothScrolling = false, {passive: true});
	window.addEventListener('touchmove', () => isSmoothScrolling = false, {passive: true});

	// Detect anchor clicks
	document.addEventListener('click', function(e) {
	const anchor = e.target.closest('a[href^="#"]');
		if (anchor) {
			isSmoothScrolling = true;
			setTimeout(() => isSmoothScrolling = false, 2000); // Reset after reasonable time
		}
	}, true);

	// Detect programmatic smooth scrolling
	const originalScrollTo = window.scrollTo;
	window.scrollTo = function(options) {
		if (typeof options === 'object' && options.behavior === 'smooth') {
			isSmoothScrolling = true;
			setTimeout(() => isSmoothScrolling = false, 2000);
		}
		return originalScrollTo.apply(this, arguments);
	};

	function onMultiResize(swiperInstance){
		swiperInstance.update(); 
		swiperInstance.slideTo(swiperInstance.activeIndex, 0);
	}

	function animateBanner(heroImage){
		const subpage = heroImage.closest('.body_sub_page');
		const inpagenav = subpage?.querySelector('.cmp-flindersonline-navigation');
		const hasNavMenu = isMobile ? inpagenav?.classList.contains('mobile_on_top') : inpagenav?.classList.contains('desktop_on_top');
		const container = heroImage.closest('.flinders-banner');
		const mode = heroImage.dataset.parallax === "true";	
		const option = container.dataset.parallaxOption;
		headerOffset = header.clientHeight > 0 ? header.clientHeight + (notification ? (notification?.classList.contains('hidden') ? 0 : 48) : 0) + (hasNavMenu ? inpagenav?.clientHeight : 0) : 0;
		var viewportHeight = window.innerHeight - headerOffset;
		var paddingTop = 0;
		const isAuthor = heroImage.closest('.cmp-flindersonline-hero-banner').dataset.author === 'true';

		var isIOSHeaderHeight = false;
		if (isIOS && isSafari && !isIOSHeaderHeight) {
			isIOSHeaderHeight = true;
			headerOffset = (header.clientHeight || 90) + (notification ? (notification?.classList.contains('hidden') ? 0 : 48) : 0);
		}

		function getCustomViewportHeight() {
			const baseViewportHeight = window.visualViewport?.height || window.innerHeight;
			return baseViewportHeight - headerOffset;
		}

		if(mode && option === 'scaleDownBlur' && !isAuthor){
			viewportHeight = getCustomViewportHeight();
			container.style.height = viewportHeight + 'px';
			container.setAttribute('data-height', viewportHeight);
			paddingTop = viewportHeight;
		}

		var isIOSPaddingTop = false;
		if (isIOS && isSafari && !isIOSPaddingTop) {
			isIOSPaddingTop = true;
			paddingTop = getCustomViewportHeight() * 0.7;
		}  
		
		const parent = heroImage.closest('.flinders-banner-content');
		const content = parent.querySelector('.hero-description');
		const image = heroImage.querySelector('.hero-image');	
		const phantom = parent.closest('.cmp-flindersonline-hero-banner').querySelector('.end-element');
		parent.style.height = "inherit";

		if(phantom){
			phantom.style.paddingTop = paddingTop + 'px';
		}
		
		const maxHeight = 80; 
				
		var startHeight = container.dataset.height;

		var maxHeightPx = startHeight * (maxHeight / 100);
		var multiplier = startHeight - maxHeightPx;

		const tl = gsap.timeline();
		const tl_content = gsap.timeline();

		gsap.set(image, {
			marginTop: 0,
			width: "90%",
			height: "90%",
			borderRadius: "24px",
			opacity: 1,
			scale: 1,
			transformPerspective: 1000,
			transformOrigin: "50% 50%"
		});

		var heroImageHeight = isAuthor ? '100%' : "inherit";

		gsap.set(heroImage, {
			position: "absolute",
			height: heroImageHeight,
			top: 0,
			left: 0,
			filter: "blur(0)"
		});

		const initializeHeroBanner = () => {
    		if (hasHashTagOnLoad && mode) {

				gsap.set(image, {
					marginTop: 0,
					width: "90%",
					height: "90%",
					borderRadius: "24px",
					opacity: 1,
					scale: 1,
					transformPerspective: 1000,
					transformOrigin: "50% 50%"
				});

				var heroImageHeight = isAuthor ? '100%' : "inherit";

				gsap.set(heroImage, {
					position: "absolute",
					height: heroImageHeight,
					top: 0,
					left: 0,
					filter: "blur(0)"
				});

				phantom.style.display = 'none';
			}
		}

		initializeHeroBanner();
		
		let lastScrollY = window.scrollY;
		let isScrollingUp = false;

		window.addEventListener('scroll', () => {
			const currentScrollY = window.scrollY;
			isScrollingUp = currentScrollY < lastScrollY;
			lastScrollY = currentScrollY;
		});

		// Create an intersection observer to detect when hero enters viewport
		const observer = new IntersectionObserver((entries) => {
			entries.forEach(entry => {
				//Needs to be declared seperately else behavior of parallax breaks
				if (entry.isIntersecting && hasHashTagOnLoad) {
					// User interacted, now enable normal behavior					
					phantom.style.display = 'block';
					phantom.style.height = paddingTop + "px";					
					hasHashTagOnLoad = false;
					return;
				} 

			    if (entry.isIntersecting) {
					// Background image zoom-in animation	
					var initScale = (isIOS && isSafari) ? 1 : 1.05;
					
					tl.to(image, {
						width: "100%",
						height: "100%",
						borderRadius: "0px",
						scale: initScale,
						duration: 1,
						ease: "none",
						opacity: 1
					}, 1);

					// Content fade-in animation
					tl_content.to(content, {
						opacity: 1,
						y: 0,
						duration: 0.8,
						ease: "none",
						stagger: .5
					}, 0.8); 

					if(!mode) return;										
		
					// Change position on scroll
					ScrollTrigger.create({
						trigger: parent,
						start: `top ${headerOffset}px`,
						endTrigger: phantom,
						end: "bottom top",
						scrub: true,
						// ...(isIOS && isSafari && {
							invalidateOnRefresh: true,
							refreshPriority: 0,
						// }),
						onUpdate: (self) => {
							startHeight = container.dataset.height;
							maxHeightPx = startHeight * (maxHeight / 100);
							multiplier = startHeight - maxHeightPx;

							const blurAmount =  mode ? Math.min(self.progress * 10, 8) : 0;							
							const widthAmount = (mode && option === 'scaleDownBlur') ? Math.max(90, 100 - (self.progress * 20)) : 100;
							
							const heightAmountPx = Math.max(maxHeightPx, startHeight - (self.progress * multiplier))
							const heightAmount = (mode && option === 'scaleDownBlur') ? (heightAmountPx  + 'px') : '100%';
							
							gsap.to(image, {
								width: `${widthAmount}%`, 
								height: heightAmount, 
								overwrite: "auto",
								stagger: .5
							});	
							
							if(option === 'blurredOnly'){
								gsap.to(heroImage, {
									filter: `blur(${blurAmount}px)`
								});
							}else{
								if(self.progress < 0.7) { 
									gsap.to(heroImage, {
										filter: "blur(0px)"
									});
								}

								if(self.progress > 0.7) { 
									gsap.to(heroImage, {
										filter: `blur(${blurAmount}px)`
									});
								}
							}
						},
						onEnter: () => {
							// When hero reaches top, make background fixed
							const orientation = container.dataset.orientation === true;
							var pos = "fixed"; 

							if(isSmoothScrolling && orientation){
								pos = "absolute";
								container.dataset.orientation = "false";
							}

							if(isIOS && isSafari){
								pos = "fixed";
							}

							gsap.set(heroImage, {
								position: pos,
							});

							gsap.set(image, {
								marginTop: headerOffset + 'px'
							})

							if(option === 'scaleDownBlur'){
								gsap.to(image, {
									borderRadius: "24px",
									scale: 1,
									stagger: .5,
									opacity: 1
								});
							}

							tl.kill();
						},
						onLeaveBack: () => {
						  if (isScrollingUp || !(isIOS && isSafari)) {
							gsap.to(heroImage, {
								position: "absolute",
								filter: "blur(0)",
								duration: 0.1,
								ease: 'none',
								stagger: 'none'
							});

							gsap.set(image, {
								marginTop: 0,
							});

							gsap.to(image, {
								height: "100%",
								width: "100%",
								borderRadius: "0",
								ease: 'none',
								stagger: 'none'
							});

							tl.kill();
						  }
						},
						onRefresh: () => {
						  if (!(isIOS && isSafari)) {
							gsap.to(heroImage, {
								position: "absolute",
								filter: "blur(0)",
								ease: 'none',
								stagger: 'none',
								duration: 0.1,
							});

							gsap.set(image, {
								marginTop: 0
							})

							gsap.to(image, {
								height: "100%",
								width: "100%",
								borderRadius: "0",
								ease: 'none',
								stagger: 'none'
							});

							tl.kill();
						  }
						}
					});
			    }
			});
		}, {
			threshold: 0.5
		});

		observer.observe(heroImage);	
	}

	function initSingleBanner(target){
		const heroImages = target.querySelectorAll('.hero_banner');
		const mode = target.dataset.parallax === "true";
		const parallaxOption = target.dataset.parallaxOption;
		// Check if image is already loaded

		heroImages.forEach(heroImage =>{				
			if(mode){
				heroImage.setAttribute('data-parallax', mode);	
				heroImage.querySelector('.hero-image').classList.add('parallax-opacity');
			}
			
			if (heroImage.complete) {
				animateBanner(heroImage);
			} else {
				heroImage.addEventListener('load', animateBanner(heroImage));
			}
		})
	}

	function initVideoBanner(target){
		const heroVideos = target?.querySelectorAll('.hero-video');
		const videoControl = target?.querySelector('.video-control-btn');
		const loopMode = target?.hasAttribute('data-loop-mode') ? true : false; 

		if(loopMode){
		  heroVideos.forEach(heroVideo =>{
			heroVideo.loop = loopMode;
		  });
		}

		// Initialize video state
		function initVideo() {
		  heroVideos.forEach(heroVideo =>{
			if (heroVideo && heroVideo.dataset && heroVideo.dataset.initialized) return;
			heroVideo.muted = true;
			heroVideo.play()
			.then(() => {
				target.querySelector('.hero_banner').classList.remove('video-paused');
				if (heroVideo && heroVideo.dataset) {
					heroVideo.dataset.initialized = "true";
				}
			})
			.catch(error => {
				console.error('Autoplay prevented:', error);
			});
		  });
		}

		initVideo();

		// Toggle play/pause
		function togglePlayPause(e) {
			var videos = target.querySelectorAll('.hero-video');
			e.stopImmediatePropagation();
		  videos.forEach(heroVideo => {
			if (heroVideo.paused) {
				heroVideo.play().catch(e => {
					console.error('Play failed:', e);
				});
				target.querySelector('.hero_banner').classList.remove('video-paused');
			} else {
				heroVideo.pause()
				target.querySelector('.hero_banner').classList.add('video-paused');	
			}
		  });
		}
		

		if(videoControl) {
			videoControl.addEventListener('click', togglePlayPause, true);
		}
		  
		// Handle when video ends (for non-looping videos)
		heroVideos.forEach(heroVideo => {
		heroVideo.addEventListener('ended', function() {
			target.querySelector('.hero_banner').classList.add('video-paused');
		});
		})

		var wasPlayingBeforeTabSwitch = false;

		document.addEventListener('visibilitychange', function() {
			var videos = target.querySelectorAll('.hero-video');
			videos.forEach(heroVideo => {
			if (document.hidden) {
				wasPlayingBeforeTabSwitch = !heroVideo.paused;
				heroVideo.pause();
			} else if (wasPlayingBeforeTabSwitch) {
				heroVideo.play().catch(e => console.error("Playback failed:", e));
			}
			});
		});
	}

	function initCarouselBannerMobile(target){
		const carousel = target.querySelector('.flinders-banner-slider');
		const slider = carousel.querySelector('.flinders-hero-swiper-mobile');
		const desktopSlides = carousel.querySelectorAll('.flinders-hero-swiper .herobanner-slide');
		const mobileSlides = carousel.querySelectorAll('.flinders-hero-swiper-mobile .herobanner-slide');
		const nav = slider.querySelector('.flinders-hero-navigation');

		desktopSlides.forEach((slide, index) => {
			const content = slide.querySelector('.hero-description');
			const mobileSlide = mobileSlides[index];
			const mobile_content = mobileSlide.querySelector('.hero-description');
			mobile_content.innerHTML = content.innerHTML;
		})
		
		if (!slider) return;

		// Timer variables
		const rotationDuration = parseInt(target.dataset.rotationDuration);
		const autoplayDelay = ((rotationDuration * 1000) + 1000) || 6000;
		const progressTrack = slider.querySelector('.progress-border');
		const frameRate = 50;
		const totalFrames = ((autoplayDelay - 1000) / 1000) * frameRate;
		var currentFrame = 0;
		var animationId;
		var mobileTL;
		var isAnimating = false;

		var swiperMobile = new Swiper(slider, {
			slidesPerView: 1,
			centeredSlides: true,
			spaceBetween: 0,
			speed: 600,
			autoplay: false,
			watchSlidesProgress: true,
			watchSlidesVisibility: true,
			slideActiveClass: 'swiper-slide-active',
			loop: true,
			effect: 'slide',
			// Navigation
			navigation: {
				nextEl: '.flinders-hero-next',
				prevEl: '.flinders-hero-prev'
			},
			// Prevent Double Clicks
			// COMPLETELY DISABLE TOUCH/DRAG
			simulateTouch: false,          
			allowTouchMove: false,       
			touchStartPreventDefault: true, 
			touchReleaseOnEdges: false,  
			preventInteractionOnTransition: true, 
			preventClicks: true,
			preventClicksPropagation: true,
			on: {
				init: function() {					
					currentFrame = 0;
					setTimeout(function() {
						slider.classList.remove('visibility');
						runAnimation();
					});
				},
				resize: function(){
					try{
						var lastIndex = parseInt(carousel.getAttribute('data-last-active-index')) || 0;
						onMultiResize(this);
					}catch (e) {
						setTimeout(() => this.update(), 100);
					}
				},
				slideChangeTransitionStart: function() {				
					nav.style.pointerEvents = 'none';
				},		
				slideChange: function() {
					this.slides.forEach(function (slide) { 
						slide.classList.remove('flinders-active-slide')
					});
					const activeSlide = this.slides[this.activeIndex];
					carousel.setAttribute('data-last-active-index', this.activeIndex);
					if(activeSlide){
						activeSlide.classList.add('flinders-active-slide');
						const buttonColor = activeSlide.dataset.buttonColor;
						nav.dataset.buttonColor = buttonColor;
					}				
				}
			}
		});

	
		// Progress animation
		function animateProgress() {
			const progress = Math.min(100, (currentFrame / totalFrames) * 100);
			progressTrack.style.setProperty('--progress', `${progress}%`);
			currentFrame++;
			
			if (progress < 100) {
				animationId = requestAnimationFrame(animateProgress);
			}
		}
	
		function startProgressTimer() {
			// Reset progress bar
			cancelAnimationFrame(animationId);
			currentFrame = 0;
			progressTrack.style.setProperty('--progress', '0%');
			
			// Start new animation
			animationId = requestAnimationFrame(animateProgress);
		}
	
		// Manual control with timer reset
		slider.querySelector('.flinders-hero-next').addEventListener('click',  function (event) {			
			nav.style.pointerEvents = 'none';
			handleButtonClick('next', event);
		}, { capture: true});
	
		slider.querySelector('.flinders-hero-prev').addEventListener('click',   function (event) {		
			nav.style.pointerEvents = 'none';
			handleButtonClick('prev', event);
		}, { capture: true});
		
		// Clean up on destroy
		swiperMobile.on('destroy',  function () {
			cancelAnimationFrame(animationId);
		});

		// Initialize GSAP and Swiper
		gsap.set(swiperMobile.slides[swiperMobile.activeIndex].querySelector('.mobile-content'), { 
			scale: 0.95, 
			borderRadius: "24px" 
		});

		function runAnimation() {
			startProgressTimer();
			if (mobileTL) mobileTL.kill();

			mobileTL = gsap.timeline({
				onComplete: () => {
					swiperMobile.slideNext();
					runAnimation(); // Restart cycle
				}
			});

			mobileTL.to(swiperMobile.slides[swiperMobile.activeIndex].querySelector('.mobile-content'), { 
				scale: 1.2,
				borderRadius: '0',
				duration: 0.8,
				ease: "ease-in-out"
			}, 0.8)
			.call(() => nav.style.pointerEvents = 'auto', null, 0.1);
			
			mobileTL.to(swiperMobile.slides[swiperMobile.activeIndex].querySelector('.mobile-content'), { 
				scale: 0.95,
				borderRadius: '24px',
				duration: 1,
				ease: "ease-in-out"
			}, rotationDuration - 1);
		}

		function handleButtonClick(direction, event) {

			// Kill the current timeline to avoid conflicts
			var activeSlide = swiperMobile.slides[swiperMobile.activeIndex];

			if (isAnimating && event) {
				event.preventDefault();
				return;
			}

			if (mobileTL) mobileTL.kill();
			
			gsap.to(activeSlide.querySelector('.mobile-content'), { 
				scale: 0.95,
				borderRadius: '24px',
				duration: 1,
				ease: "back.out",
				onComplete: () => {
					if (direction === 'next') swiperMobile.slideNext();
					else swiperMobile.slidePrev();
					runAnimation();
				}
			});
			
			isAnimating = true;
			setTimeout(() => {
				isAnimating = false;
			}, 600);

			//NOTE(Christof): prevent the event from bubbling, so that swiper doesn't fire it's default slide behaviour
			if(event){
				event.stopImmediatePropagation();
				event.preventDefault();
			}
		}
	}

	function initCarouselBannerDesktop(target){
		const carousel = target.querySelector('.flinders-banner-slider');
		const slider = carousel.querySelector('.flinders-hero-swiper');
		const content = slider.querySelectorAll('.herobanner-content')
		const nav = slider.querySelector('.flinders-hero-navigation');
		
		if (!slider) return;		

		const rotationDuration = parseInt(target.dataset.rotationDuration);
        const autoplayDelay = ((rotationDuration * 1000) + 1000) || 6000;	
		const progressTrack = slider.querySelector('.progress-border');
        const frameRate = 50; 
        const totalFrames = (autoplayDelay / 1000) * frameRate;
        var currentFrame = 0;
        var animationId;
		var masterTL;

		// Initialize GSAP and Swiper
		gsap.set(content, { 
			scale: 0.9, 
			borderRadius: "24px" 
		});
    
		var swiperDesktop = new Swiper(slider, {
			slidesPerView: 1,
			allowTouchMove: false,
			autoplay: false,
			loop: true,	
			preventClicks: true,
			preventClicksPropagation: true,	
			on: {
				init: function() {
					startProgressAnimation();
					currentFrame = 0;
				},
				resize: function(){
					try {
						var lastIndex = parseInt(carousel.getAttribute('data-last-active-index')) || 0;
						onMultiResize(this);
					}catch (e) {
						setTimeout(() => this.update(), 100);
					}
				},
				slideChange: function(){					
					carousel.setAttribute('data-last-active-index', this.activeIndex);
				},
				slideChangeTransitionStart: function() {
					progressTrack.style.setProperty('--progress', '100%');
					cancelAnimationFrame(animationId);							
					nav.style.pointerEvents = 'none';		
				},
				slideChangeTransitionEnd: function() {
					startProgressAnimation();			
				}
			}
			});

		function animateProgress() {
            const progress = Math.min(100, (currentFrame / totalFrames) * 100);
            progressTrack.style.setProperty('--progress', `${progress}%`);
            currentFrame++;
            
            if (progress < 100) {
                animationId = requestAnimationFrame(animateProgress);
            }
        }
        
        function startProgressAnimation() {
            cancelAnimationFrame(animationId);
            currentFrame = 0;
            progressTrack.style.setProperty('--progress', '0%');
            animationId = requestAnimationFrame(animateProgress);
        }
		
		const CYCLE_DURATION = autoplayDelay; 
		
		function runAnimation() {
			if (masterTL) masterTL.kill();

			masterTL = gsap.timeline({
				onComplete: () => {
					swiperDesktop.slideNext();
					runAnimation(); // Restart cycle
				}
			});
			
			masterTL.to(content, { 
				scale: 1,
				borderRadius: '0',
				duration: 1,
				ease: "power2.in"
			}, 0)			
			.call(() => nav.style.pointerEvents = 'auto', null, 0.1);
			
			masterTL.to(content, { 
				scale: 0.9,
				borderRadius: '24px',
				duration: 1,
				ease: "ease-in-out"
			}, rotationDuration - 1);

		}
		
		function handleButtonClick(direction) {
			// Kill the current timeline to avoid conflicts
			if (masterTL) masterTL.kill();
			
			gsap.to(content, { 
				scale: 0.9,
				borderRadius: '24px',
				duration: 1,
				ease: "back.out",
				onComplete: () => {
					if (direction === 'next') swiperDesktop.slideNext();
					else swiperDesktop.slidePrev();
					runAnimation();
				}
			});
		}
		
		slider.querySelector('.flinders-hero-next').addEventListener('click', function() {		
			nav.style.pointerEvents = 'none';
			handleButtonClick('next');
		});
		
		slider.querySelector('.flinders-hero-prev').addEventListener('click', function() {		
			nav.style.pointerEvents = 'none';
			handleButtonClick('prev');
		});

		swiperDesktop.on('slideChange', function () {
			const activeSlide = swiperDesktop.slides[swiperDesktop.activeIndex];
			const slideData = activeSlide.dataset;
			const buttonColor = slideData.buttonColor;
			nav.dataset.buttonColor = buttonColor;
		});
		
		runAnimation();	
	}

	function checkIfHasTagOnLoad() {
		// Enhanced detection: check both hash and scroll position
		const component = document.querySelector('.cmp-flindersonline-hero-banner');
		const isAuthor = component?.dataset.author === 'true';

		if(!isAuthor && component){
			const isPageLoadNotAtTop = () => {
				const hasHashInURL = window.location.hash !== '';
				const isScrolledDown = window.pageYOffset > 0 || document.documentElement.scrollTop > 0;
				return hasHashInURL || isScrolledDown;
			};

			if (isPageLoadNotAtTop()) {
				hasHashTagOnLoad = true;
				
				// Set up reset mechanism for both scroll and user interaction
				const resetOnInteraction = () => {
					hasHashTagOnLoad = false;
					window.removeEventListener('scroll', resetOnInteraction);
					window.removeEventListener('touchstart', resetOnInteraction);
					window.removeEventListener('mousedown', resetOnInteraction);
					window.removeEventListener('keydown', resetOnInteraction);
				};
				
				// Reset on any user interaction
				window.addEventListener('scroll', resetOnInteraction, { once: true });
				window.addEventListener('touchstart', resetOnInteraction, { once: true });
				window.addEventListener('mousedown', resetOnInteraction, { once: true });
				window.addEventListener('keydown', resetOnInteraction, { once: true });
			}
		}
	}
	
	// Main initialization function
	function initHeroBannerSliders() {
		const components = document.querySelectorAll('.cmp-flindersonline-hero-banner');
		if (!components.length) return;

		checkIfHasTagOnLoad();		

		components.forEach(component => {
			const herobanner = component.querySelector('.flinders-banner');
			const carouselBanners = component.querySelectorAll('.herobanner-slide');
			const parallax_mode = component.hasAttribute('data-parallax-mode') ? true : false;
			const banner_type = component.dataset.bannerType;
			const banner_mobile_height = (component.dataset.bannerMobileHeight || 450);
			const banner_desktop_height = (component.dataset.bannerDesktopHeight || 750);
			const banner_alignment = component.dataset.placeholderAlignment;
			const section = component.closest('.component_section');

			const isAuthor = component.dataset.author === 'true';

			const parallaxOption = component.dataset.parallaxOption || 'scaleDownBlur';

			if(herobanner){
				if(banner_type !== 'multi'){
					herobanner.style.setProperty('height', (isAuthor ? 'auto' : (isMobile ? banner_mobile_height : banner_desktop_height) + 'px'));
					herobanner.classList.add(banner_alignment);
				}
			}
				
			if(section){
				section.style.position = "relative";
				// Set z-index based on conditions
				if (banner_type === 'video') {
					section.style.zIndex = "0";
				} else if (parallax_mode && banner_type !== 'multi') {
					section.style.zIndex = "-1";
				} else if (!section.classList.contains('white_container') || !parallax_mode) {
					section.style.zIndex = "0";
				}
			}
			
		  if(herobanner){
			if(banner_type === 'multi'){
				if(!isAuthor){
					if(herobanner.querySelector('.flinders-banner-slider')){
						initCarouselBannerMobile(herobanner);
						initCarouselBannerDesktop(herobanner);
					}
				} else{
					const sliderWrapper = component.querySelector('.swiper-wrapper'); 
					sliderWrapper.style.flexDirection = 'column';
				}

				carouselBanners.forEach(banner => {
					banner.style.setProperty('height', (isAuthor ? 'auto' : (isMobile ? banner_mobile_height : banner_desktop_height) + 'px'));
				})
			}else if(banner_type === 'video'){
				if(!isAuthor){
					initVideoBanner(herobanner);
				}
			}else{
				if(herobanner){
					herobanner.setAttribute('data-parallax', parallax_mode);
					herobanner.setAttribute('data-parallax-option', parallaxOption);
					herobanner.setAttribute('data-height', (isMobile ? banner_mobile_height : banner_desktop_height));
					initSingleBanner(herobanner);
				}
			}
		  }	
		})
	}

	// Execute when DOM is ready using the most efficient method
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initHeroBannerSliders);
	} else {
		// If already loaded, run immediately but in the next frame for better performance
		requestAnimationFrame(initHeroBannerSliders);
	}

	var resizeTimeout;
	function handleResize() {
		const components = document.querySelectorAll('.cmp-flindersonline-hero-banner');

		clearTimeout(resizeTimeout);
		isMobile = window.innerWidth < 992; ///iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
		resizeTimeout = setTimeout(() => {	
			components.forEach(component => {
				const herobanner = component.querySelector('.flinders-banner');
				const carouselBanners = component.querySelectorAll('.herobanner-slide');
				const banner_mobile_height = (component.dataset.bannerMobileHeight || 450);
				const banner_desktop_height = (component.dataset.bannerDesktopHeight || 750);
				const banner_type = component.dataset.bannerType;
				const isAuthor = component.dataset.author === 'true';
				const parallax = component.hasAttribute('data-parallax-mode') ? true : false;
				const parallaxOption = component.dataset.parallaxOption;
				
				const subpage = herobanner?.closest('.body_sub_page');
				const inpagenav = subpage?.querySelector('.cmp-flindersonline-navigation');
				const hasNavMenu = isMobile ? inpagenav?.classList.contains('mobile_on_top') : inpagenav?.classList.contains('desktop_on_top');

				const scrollY = window.scrollY;
				const viewportHeight = window.innerHeight;
				const heroTop = herobanner?.offsetTop;
				const heroBottom = heroTop + (herobanner?.offsetHeight * 2);

				const isVisible = (heroTop <= scrollY + viewportHeight) && (heroBottom >= scrollY);

				if(herobanner){
					if(banner_type !== 'multi'){
						herobanner.style.setProperty('height', (isAuthor ? 'auto' : (isMobile ? banner_mobile_height : banner_desktop_height) + 'px'));
						herobanner.setAttribute('data-height', (isMobile ? banner_mobile_height : banner_desktop_height));

						if(banner_type === 'single' && parallax && parallaxOption === 'scaleDownBlur' && !isAuthor){
							headerOffset = header.clientHeight + (hasNavMenu ? inpagenav?.clientHeight : 0);
							const newHeight = viewportHeight - headerOffset;
							herobanner.setAttribute('data-orientation', 'true');
							herobanner.style.setProperty('height', newHeight + 'px');
							herobanner.setAttribute('data-height', newHeight);
							const images = herobanner.querySelectorAll('.hero-image');

							images.forEach(image => {
								if(!(isIOS && isSafari)){	
									gsap.set(image, {
										marginTop: 0,
									})
								}
							})

							if(isVisible){
								isSmoothScrolling = false;
								if(!(isIOS && isSafari)){						
									window.scrollTo({
										top: heroTop,
										behavior: 'auto'
									});
								}
							}
						}
						
						if(isAuthor)
							herobanner.style.setProperty('min-height', isMobile ? banner_mobile_height : banner_desktop_height + 'px');
					}else{
						carouselBanners.forEach(banner => {
							banner.style.setProperty('height', (isAuthor ? 'auto' : (isMobile ? banner_mobile_height : banner_desktop_height) + 'px'));
							
							if(isAuthor)
								banner.style.setProperty('min-height', isMobile ? banner_mobile_height : banner_desktop_height + 'px');
						});
					}
				}
			});
		}, 250); 
	} 
	window.addEventListener('resize', handleResize);
})();